import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["sources"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import SingleAvatar from './SingleAvatar';
import MultiAvatar from './MultiAvatar';
var Avatar = /*#__PURE__*/memo(function (_ref) {
  var sources = _ref.sources,
    props = _objectWithoutProperties(_ref, _excluded);
  var Component = sources ? MultiAvatar : SingleAvatar;
  var finalProps = useMemo(function () {
    return sources ? _objectSpread({
      sources: sources
    }, props) : _objectSpread({}, props);
  }, [props, sources]);
  return /*#__PURE__*/React.createElement(Component, finalProps);
});
Avatar.defaultProps = {
  type: 'round',
  size: 'medium'
};
process.env.NODE_ENV !== "production" ? Avatar.propTypes = {
  sources: PropTypes.arrayOf(PropTypes.shape({
    src: PropTypes.string,
    placeholder: PropTypes.string,
    alt: PropTypes.string
  })),
  src: PropTypes.string,
  placeholder: PropTypes.string,
  alt: PropTypes.string,
  icon: PropTypes.string,
  type: PropTypes.oneOf(['round', 'square']),
  size: PropTypes.oneOf(['tiny', 'small', 'medium', 'large', 'big', 'huge'])
} : void 0;
export default Avatar;